import * as React from 'react';
import { Settings } from "../types";

export const SettingsContext: React.Context<Settings> = React.createContext<Settings>({
    apiUrl: '',
    type: ''
});
